"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bitcoinjsLib = require("bitcoinjs-lib");

var _mainnet = require("../../config/networks/flo/mainnet");

var _FLOTransaction = _interopRequireDefault(require("./FLOTransaction"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FLOTransactionBuilder = /*#__PURE__*/function (_bitcoinjsLib$Transac) {
  _inherits(FLOTransactionBuilder, _bitcoinjsLib$Transac);

  var _super = _createSuper(FLOTransactionBuilder);

  function FLOTransactionBuilder() {
    var _this;

    _classCallCheck(this, FLOTransactionBuilder);

    var network = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _mainnet.network;
    var maximumFeeRate = arguments.length > 1 ? arguments[1] : undefined;
    _this = _super.call(this, network, maximumFeeRate);
    _this.__TX = new _FLOTransaction.default();
    _this.__TX.version = 2;
    return _this;
  }

  _createClass(FLOTransactionBuilder, [{
    key: "setFloData",
    value: function setFloData(data, dataType) {
      return this.__TX.setFloData(data, dataType);
    }
  }]);

  return FLOTransactionBuilder;
}(_bitcoinjsLib.TransactionBuilder);

var _default = FLOTransactionBuilder;
exports.default = _default;